import React, { Fragment, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import axios from 'axios';

const TERM = ['', '上学期', '下学期'];

export default function UserModal({ data, onClose }) {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const { id, schoolName, year, term } = data;

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
  };

  const onFinish = (values) => {
    axios({
      url: '/api/report/submit',
      method: 'POST',
      params: { id },
      data: values,
    }).then(({ code, msg }) => {
      if (code === 0) {
        onClose();
        setVisible(false);
        return message.success('操作成功');
      }
      message.error(msg);
    });
  };

  return (
    <Fragment>
      <a onClick={() => setVisible(true)}>申请</a>
      <Modal
        title="上报提交"
        visible={visible}
        onOk={() => form.submit()}
        onCancel={() => setVisible(false)}
      >
        <Form {...layout} form={form} hideRequiredMark onFinish={onFinish}>
          <Form.Item label="学校">
            {`${schoolName}${year - 1}-${year}年${TERM[term]}`}
          </Form.Item>
          <Form.Item label="备注" name="comment" rules={[{ required: true }]}>
            <Input.TextArea rows={5} />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
}
